export { TrioCta as GetStartedTrioCta } from "./trio-cta"
export type { TrioCtaProps as GetStartedTrioCtaProps } from "./trio-cta"
